import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { DisclosureModule } from '@ddt-web/disclosure';

import { SimpleDcrContentDialogComponent } from './simple-dcr-content-dialog.component';

@NgModule({
	imports: [CommonModule, SharedModule, CwpNgFrameworkModule, DisclosureModule],
	declarations: [SimpleDcrContentDialogComponent],
	exports: [SimpleDcrContentDialogComponent]
})
export class SimpleDcrContentDialogModule { }
